import { ColDef, ICellRendererParams } from 'ag-grid-community';
import { EXCEL_DATE_STYLE_ID } from 'src/constants/agGrid';
import { emptyCellFormatter } from 'src/util/grid/cellFormatter';
import { getStatusFromStartEndDates, getYYYYMMDDUTCStrFromTimestamp } from 'src/util/grid/cellGetter';
import {
    getPhoneToolLinkCellRenderer,
    getStatusCellRenderer,
    getTerritoryFlagRenderer
} from 'src/util/grid/cellRenderer';
import { dateFilterOptions } from 'src/util/grid/filter';
import { dateComparator, dateFilterComparator } from 'src/util/grid/sort';

export const basePlanLaunchDatesColDefs: ColDef[] = [
    {
        headerName: 'Base plan ID',
        field: 'basePlanName',
        filter: 'agSetColumnFilter',
        width: 400,
        minWidth: 150
    },
    {
        headerName: 'Territory',
        field: 'territoryCode',
        filter: 'agSetColumnFilter',
        cellRenderer: (params: ICellRendererParams) => getTerritoryFlagRenderer(params, false),
        minWidth: 120
    },
    {
        headerName: 'Start date',
        field: 'startDate',
        comparator: dateComparator,
        filter: 'agDateColumnFilter',
        filterParams: {
            filterOptions: dateFilterOptions,
            defaultOption: 'greaterThanOrEqual',
            comparator: dateFilterComparator,
            includeBlanksInLessThan: true,
            includeBlanksInGreaterThan: true
        },
        cellClass: EXCEL_DATE_STYLE_ID,
        valueGetter: getYYYYMMDDUTCStrFromTimestamp,
        minWidth: 120
    },
    {
        headerName: 'End date',
        field: 'endDate',
        comparator: dateComparator,
        filter: 'agDateColumnFilter',
        filterParams: {
            filterOptions: dateFilterOptions,
            defaultOption: 'lessThanOrEqual',
            comparator: dateFilterComparator,
            includeBlanksInLessThan: true,
            includeBlanksInGreaterThan: true
        },
        cellClass: EXCEL_DATE_STYLE_ID,
        valueFormatter: emptyCellFormatter,
        valueGetter: getYYYYMMDDUTCStrFromTimestamp,
        minWidth: 120
    },
    {
        headerName: 'Last updated',
        field: 'lastUpdated',
        comparator: dateComparator,
        filter: 'agDateColumnFilter',
        filterParams: {
            filterOptions: dateFilterOptions,
            defaultOption: 'greaterThanOrEqual',
            comparator: dateFilterComparator,
            includeBlanksInLessThan: true,
            includeBlanksInGreaterThan: true
        },
        cellClass: EXCEL_DATE_STYLE_ID,
        valueGetter: getYYYYMMDDUTCStrFromTimestamp,
        minWidth: 180
    },
    {
        headerName: 'Updated by',
        field: 'updatedBy',
        filter: 'agSetColumnFilter',
        cellRenderer: getPhoneToolLinkCellRenderer,
        minWidth: 150
    },
    {
        headerName: 'Status',
        field: 'status',
        filter: 'agSetColumnFilter',
        valueGetter: getStatusFromStartEndDates,
        cellRenderer: getStatusCellRenderer,
        cellRendererParams: {
            displayText: true
        },
        minWidth: 120
    },
    {
        headerName: 'Created',
        field: 'created',
        comparator: dateComparator,
        filter: 'agDateColumnFilter',
        filterParams: {
            filterOptions: dateFilterOptions,
            defaultOption: 'greaterThanOrEqual',
            comparator: dateFilterComparator,
            includeBlanksInLessThan: true,
            includeBlanksInGreaterThan: true
        },
        cellClass: EXCEL_DATE_STYLE_ID,
        valueGetter: getYYYYMMDDUTCStrFromTimestamp,
        hide: true
    },
    {
        headerName: 'Created by',
        field: 'createdBy',
        filter: 'agSetColumnFilter',
        cellRenderer: getPhoneToolLinkCellRenderer,
        hide: true
    }
];
